
import React, { useState, useRef, useEffect } from "react";
import { logFrontendException } from '../../../../../Utils/Exception';
import { useTheme } from '../../../../../GlobalContext/GlobalContext';
import { postData } from '../../../../../ApiServices/ApiService';
import { ORG_CONFIGURATION_CONTACT_CENTER,ORG_IMPORT_MASTER_TEMPLATES } from '../../../../../ApiServices/BaseURL';
import * as XLSX from 'xlsx';

const SMSContactController = (setSmsList, smsList, setSmsError, smsError, setSmsLoading, smsLoading, onRefresh, handleRefreshAllTabs) => {
  const [whatsAppFilterError, setWhatsAppFilterErrror] = useState('')
  const [filterData, setFilterData] = useState({
    contactName: "",
    phoneNo: "",
    optOut: "",
    countryCode: "",
  });

  const resetFilters = () => {
    setFilterData({
      contactName: "",
      phoneNo: "",
      optOut: "",
      countryCode: "",
    });
    setWhatsAppFilterErrror('')
  };

  const handleInputChange = (field, value) => {
    setFilterData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const itemsPerPage = 10; // Number of items per page
  const totalPages = Math.ceil(smsList?.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentContacts = smsList?.slice(indexOfFirstItem, indexOfLastItem);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleOpenDeleteModal = () => {
    setIsDeleteModalOpen(true); // Open the modal
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false); // Close the modal
    setSelectedDocument(null);
  };

  const handleDelete = (contact, index) => {
    setSelectedDocument({ contact, index }); // Store the credential to delete
    setIsDeleteModalOpen(true); // Open the confirmation modal
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const pageName = "SMSContactController";
  const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
  const { setIsLoginPopup } = useTheme();
  const fetchFilterSmsList = async () => {
    setWhatsAppFilterErrror('')
    try {
      if (!filterData.contactName && !filterData.phoneNo && !filterData.optOut) {
        setWhatsAppFilterErrror('Please fill at least one field to search.');
        return; // Stop execution if all fields are empty
      }
      if (filterData.contactName && filterData.contactName.trim().length < 3) {
      setWhatsAppFilterErrror('Enter at least three letters for Contact Name.');
      return;
    }

    if (filterData.phoneNo && filterData.phoneNo.trim().length < 3) {
      setWhatsAppFilterErrror('Enter at least three digits for Phone Number.');
      return;
    }
    setSmsLoading(true);
    setSmsError('');
    setSmsList([])
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payload = {
        "action_type": "filter_contact",
        "emp_id_auth": storedUserInfo?.emp_id,
        "contact_name": filterData.contactName || "",
        "contact_no": filterData.phoneNo || "",
        "opt_out": filterData.optOut? filterData.optOut.toLowerCase() === 'yes' ? 1 : 0: null,
        "communication_channel": 'phone'
      }
      const response = await postData(ORG_CONFIGURATION_CONTACT_CENTER, payload);
      const responseData = await response.json();


      if (response.status === 200 && responseData.status_code === 200) {
        if (responseData.message.toLowerCase() === "success") {
          if (responseData?.dataJ?.length > 0) {
            setSmsList(responseData?.dataJ || []);
            setCurrentPage(1);
          } else {
            setSmsError(responseData?.info || "Failed to fetch whatsapp conatcts.");
            // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, "fetchFilterwhatsAppList", responseData || '');

          }
        } else {
          setSmsError(responseData?.info || "Failed to fetch whatsapp conatcts.");
          // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "fetchFilterwhatsAppList", responseData || '');
        }
      } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setSmsError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchFilterSmsList", responseData || response || '');

      } else {
        setSmsError(responseData?.info || "Failed to fetch whatsapp conatcts.");
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchFilterSmsList", responseData || response || '');
      }
    } catch (err) {
      setSmsError("Network error. Please try again.");
      logFrontendException(storedUserId, pageName, "fetchFilterSmsList-catch", err || '');
    } finally {
      setSmsLoading(false);
    }
  };

  const [deleteContactLoading, setDeleteContactLoading] = useState(false);
  const [deleteContactError, setDeleteContactError] = useState('');
  const [deleteContactSuccess, setDeleteContactSuccess] = useState('');
  const [deletedMessages, setDeletedMessages] = useState([]);
  const [currentContacteDeleteIndex, setCurrentContactDeleteIndex] = useState(null);
  const callDeleteWhatsAppContact = async () => {
    setCurrentContactDeleteIndex(null)
    console.log("sel", selectedDocument)
    try {
      const { contact, index } = selectedDocument;
      setDeleteContactLoading(true);
      setDeleteContactError('')
      setDeleteContactSuccess('')
      setCurrentContactDeleteIndex(index)
      console.log("contact", contact)
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = {
        "action_type": "delete_contact",
        "emp_id_auth": storedUserInfo?.emp_id,
        "contact_id": contact?.contact_id
      }
      console.log('payload', payLoad)

      // Make the API call
      const response = await postData(ORG_CONFIGURATION_CONTACT_CENTER, payLoad);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.status_code === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setDeleteContactError('')
            setDeletedMessages((prevDeleted) => [...prevDeleted, contact.contact_id]);
            setDeleteContactSuccess(responseData?.info)
            setTimeout(() => {
              onRefresh();
              setDeleteContactSuccess('');
              setCurrentPage(1);
              handleRefreshAllTabs();
            }, 3000);
          } else {
            setDeleteContactError(responseData?.info || 'Failed to delete whatsapp contact. Please try again.');
            // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, `callDeleteWhatsAppContact`, responseData || '');
          }
        } else {
          setDeleteContactError(responseData?.info || 'Failed to delete whatsapp contact. Please try again...');
          // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, `callDeleteWhatsAppContact`, responseData?.info || responseData || '');
        }
      } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setDeleteContactError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, `callDeleteWhatsAppContact`, responseData || response || '');

      } else {
        setDeleteContactError('Unexpected error occurred. Please try again later.');
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, `callDeleteWhatsAppContact`, response || '');
      }
    } catch (error) {
      setDeleteContactError(`Failed to delete whatsapp contact. Please check your network connection and try again.`);
      // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
      logFrontendException(storedUserId, pageName, `callDeleteWhatsAppContact`, error || '');

    } finally {
      setDeleteContactLoading(false);
    }
  }

  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click(); // trigger file input click
  };
  const [bulkContactsUploadError, setBulkContactsUploadError] = useState('');
  const [bulkContactsUploadSuccess, setBulkContactsUploadSuccess] = useState('')
  const [bulkContactsUploadLoading, setBulkContactsUploadLoading] = useState(false)
  const handleFileChange = (event) => {
    setBulkContactsUploadError('')
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

      if (!jsonData.length) {
        setBulkContactsUploadError("Invalid Excel file: No data found.");
        event.target.value = null
        return;
      }

      const records = [];
      const errors = [];
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const emp_id_auth = storedUserInfo?.emp_id || 0;

      jsonData.forEach((row, index) => {
        const record = {};

        const rowNumber = index + 2; // Excel rows start from row 2 (excluding header)

        const contactName = row["Name"]?.trim();
        const contactNo = row["Phone No."]?.toString().trim();
        const emailId = row["Email ID"]?.trim();
        const listName = row["List Name"]?.trim();
        const channel = row["Channel"]?.toLowerCase().trim();
        const fileNumber = row["File Number"] !== undefined && row["File Number"] !== null
          ? row["File Number"].toString().trim()
          : null;
        const optOutRaw = row["Opt-Out"]?.toLowerCase();

        record.contact_name = contactName || null;
        record.contact_no = contactNo || null;
        record.email_id = emailId || null;
        record.list_name = listName || null;
        record.communication_channel = channel || null;
        record.client_file_id = fileNumber;
        record.opt_out = optOutRaw === "yes" ? 1 : 0;
        record.added_on = emp_id_auth;

        // Basic validations
        if (!contactName) {
          errors.push(`Row ${rowNumber}: Name is required.`);
        }

        if (!channel || !["whatsapp", "sms", "email"].includes(channel)) {
          errors.push(`Row ${rowNumber}: Invalid or missing communication channel.`);
        }

        if (!listName) {
          errors.push(`Row ${rowNumber}: List Name is required.`);
        }

        if (!optOutRaw || (optOutRaw !== "yes" && optOutRaw !== "no")) {
          errors.push(`Row ${rowNumber}: Opt-Out must be 'Yes' or 'No'.`);
        }

        // Channel-based conditional validation
        if ((channel === "whatsapp" || channel === "sms") && !contactNo) {
          errors.push(`Row ${rowNumber}: Phone Number is required for ${channel.toUpperCase()} channel.`);
        }
        if ((channel === "whatsapp" || channel === "sms") && contactNo && !/^\d{10}$/.test(contactNo)) {
          errors.push(`Row ${rowNumber}: Phone Number must be exactly 10 digits for ${channel.toUpperCase()} channel.`);
        }

        if (channel === "email" && emailId && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailId)) {
          errors.push(`Row ${rowNumber}: Invalid Email ID format.`);
        }


        if (channel === "email" && !emailId) {
          errors.push(`Row ${rowNumber}: Email ID is required for EMAIL channel.`);
        }

        records.push(record);
      });


      if (errors.length > 0) {
        setBulkContactsUploadError(errors.join("\n"));
        event.target.value = null
        return;
      }

      const payload = {
        "action_type": 'bulk_contacts_upload',
        emp_id_auth,
        contact_list: records
      };

      console.log("Final Payload:", payload);
      handleBulkContactUpload(payload);
      event.target.value = null
    };

    reader.readAsArrayBuffer(file);
  };


  const handleBulkContactUpload = async (payload) => {
    const storedUserId = JSON.parse(localStorage.getItem('_userInfo_'));
    try {

      // setError('');
      setBulkContactsUploadError('')
      setBulkContactsUploadSuccess('');
      setBulkContactsUploadLoading(true);
      const response = await postData(ORG_CONFIGURATION_CONTACT_CENTER, payload);
      const responseData = await response.json();
      //console.log('response Data', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.status_code === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setBulkContactsUploadError('')
            setBulkContactsUploadSuccess(responseData?.info);
            // onRefresh();
            // clearFeilds();
            setTimeout(() => {
              // handleClose();
              // handleCancleClick();
              handleRefreshAllTabs();
              setBulkContactsUploadSuccess('');
            }, 3000);
          } else {
            setBulkContactsUploadError(responseData?.info || 'Failed to upload xlsx file.');
            // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, "handleBulkContactUpload", responseData || '');
          }
        } else {
          setBulkContactsUploadError(responseData?.info || 'Failed to upload xlsx file.Please try again.');
          // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "handleBulkContactUpload", responseData || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setBulkContactsUploadError('Unauthorized access. Your session may have expired. Please log in again.');
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "handleBulkContactUpload", response || '');
        setIsLoginPopup(true)
      }
      else {
        setBulkContactsUploadError('Failed to upload xlsx fil. Please try again later.');
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "handleBulkContactUpload", response || '');
      }
    } catch (error) {
      setBulkContactsUploadError(`Failed to upload xlsx file. Please check your network connection and try again.`);
      // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
      logFrontendException(storedUserId, pageName, "handleBulkContactUpload-catch", error || '');

    } finally {
      setBulkContactsUploadLoading(false);
      // onRefresh();
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    }

  };

  const [importMasterTemplateError, setImportMasterTemplateError] = useState('');
            const [importMasterTemplatesLoading, setImportMasterTemplatesLoading] = useState(false)
            const handleImportMasterTemplates = async () => {
                try {
                    setImportMasterTemplatesLoading(true);
                    setImportMasterTemplateError('');
        
                    const payload = {
                        file: "contacts_import",
                    };
        
                    console.log('handle Bulk Update Of CLient Information payload', payload);
                    // return
                    // Make the API call
                    const response = await postData(ORG_IMPORT_MASTER_TEMPLATES, payload);
                    const responseData = await response.json();
                    //console.log('response Data', responseData);
        
                    // Check for success (200) and internal status code
                    if (response?.status === 200) {
                        if (responseData?.statusCode === 200) {
                            if (responseData?.message.toLowerCase() === 'success') {
                                setImportMasterTemplateError('')
                                const downloadUrl = responseData.dataJ[0]?.download_url;
                                downloadFile(downloadUrl);
                            } else {
                                setImportMasterTemplateError(responseData?.info || 'Failed to download xlsx file. Please try again.');
                                logFrontendException(storedUserId, pageName, "handleImportMasterUpload", responseData || '');
                            }
                        } else {
                            setImportMasterTemplateError(responseData?.info || 'Failed to download xlsx file. Status code error.');
                            logFrontendException(storedUserId, pageName, "handleImportMasterUpload", responseData || response || '');
                        }
                    }
                    // Token-related errors: 400, 401, 403
                    else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                        setImportMasterTemplateError('Unauthorized access. Your session may have expired. Please log in again.');
                        logFrontendException(storedUserId, pageName, "handleImportMasterUpload", response || '');
                   
                    }
                    else {
                        setImportMasterTemplateError('Unexpected error occurred. Please try again later.');
                        logFrontendException(storedUserId, pageName, "handleImportMasterUpload", response || '');
                    }
                } catch (error) {
                    setImportMasterTemplateError(`Failed to download xlsx file. Please check your network connection and try again.`);
                    logFrontendException(storedUserId, pageName, "handleImportMasterUpload-catch", error || '');
                    
                } finally {
                    setImportMasterTemplatesLoading(false);
                }
            };
    
            const downloadFile = (url) => {
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Schedule Report.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            };

  const emailContactData = [
    {
      contactName: "Contact Name",
      emailId: "example@example.com",
      listName: "Group Name",
      addedOn: "11/11/2024",
      addedBy: "John Doe",
      optOut: "Yes",
      contactNo: '9876543223'
    },
    {
      contactName: "Contact Name",
      emailId: "example@example.com",
      listName: "Group Name",
      addedOn: "11/11/2024",
      addedBy: "John Doe",
      optOut: "Yes",
      contactNo: '9876543223'
    },
    {
      contactName: "Contact Name",
      emailId: "example@example.com",
      listName: "Group Name",
      addedOn: "11/11/2024",
      addedBy: "John Doe",
      optOut: "Yes",
      contactNo: '9876543223'
    },
    {
      contactName: "Contact Name",
      emailId: "example@example.com",
      listName: "Group Name",
      addedOn: "11/11/2024",
      addedBy: "John Doe",
      optOut: "No",
      contactNo: '9876543223'
    }
  ]


  return {
    filterData,
    setFilterData,
    emailContactData,
    handleInputChange,
    handlePageChange,
    currentPage,
    currentContacts,
    totalPages,
    setSelectedDocument,
    selectedDocument,
    fetchFilterSmsList,
    resetFilters,
    setWhatsAppFilterErrror,
    whatsAppFilterError,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    handleDelete,
    deletedMessages,
    deleteContactSuccess,
    deleteContactError,
    deleteContactLoading,
    callDeleteWhatsAppContact,
    currentContacteDeleteIndex,

    handleFileChange,
    handleButtonClick,
    fileInputRef,
    bulkContactsUploadError,
    bulkContactsUploadSuccess,
    bulkContactsUploadLoading,
    importMasterTemplatesLoading,
    importMasterTemplateError,
    handleImportMasterTemplates
  }

}

export default SMSContactController